
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.23463 6.28707L3.832 0.695312H16.168L17.7654 6.28707H20L18.0599 18.9029H1.94013L0 6.28707H2.23463ZM15.0873 2.12759H4.91274L3.72417 6.28707H16.2758L15.0873 2.12759ZM18.3015 7.71934H1.69854L3.14758 17.4706H16.8524L18.3015 7.71934ZM5.55603 14.2431V10.9469H6.9883V14.2431H5.55603ZM9.28386 14.2431V10.9469H10.7161V14.2431H9.28386ZM13.0117 14.2431V10.9469H14.444V14.2431H13.0117Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Basket',
    }) as DefineComponent
    </script>
    